module.exports = __webpack_public_path__ + "static/img/autumn_pingguoPic.af0613dd.png";